module.exports = require("json-refs");